import { render, staticRenderFns } from "./LeitorForm.vue?vue&type=template&id=64459072"
import script from "./LeitorForm.vue?vue&type=script&lang=js"
export * from "./LeitorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports